module.exports = __webpack_public_path__ + "static/avatar.cc13aa9f.jpg";


//////////////////
// WEBPACK FOOTER
// ./themes/identity/images/avatar.jpg
// module id = 290
// module chunks = 94528214525873